/**
 * Search Module
 * Header search functionality
 */

export function initSearchHeader() {
  const searchToggle = document.querySelector(".search-toggle");
  const headerSearch = document.querySelector(".header-search");
  const searchInput = document.querySelector('.header-search input[type="search"]');
  const searchIcon = searchToggle ? searchToggle.querySelector(".icon-search") : null;
  const closeIcon = searchToggle ? searchToggle.querySelector(".icon-close") : null;

  if (!searchToggle || !headerSearch) {
    return;
  }

  function openSearch() {
    headerSearch.classList.add("active");
    searchToggle.classList.add("active");
    if (searchIcon) searchIcon.style.display = "none";
    if (closeIcon) closeIcon.style.display = "inline-flex";
    if (searchInput) {
      requestAnimationFrame(() => {
        searchInput.focus();
      });
    }
  }

  function closeSearch() {
    headerSearch.classList.remove("active");
    searchToggle.classList.remove("active");
    if (searchIcon) searchIcon.style.display = "inline-flex";
    if (closeIcon) closeIcon.style.display = "none";
  }

  searchToggle.addEventListener("click", (e) => {
    e.preventDefault();
    if (headerSearch.classList.contains("active")) {
      closeSearch();
    } else {
      openSearch();
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && headerSearch.classList.contains("active")) {
      closeSearch();
    }
  });

  document.addEventListener("click", (e) => {
    if (
      headerSearch.classList.contains("active") &&
      !e.target.closest(".header-search") &&
      !e.target.closest(".search-toggle")
    ) {
      closeSearch();
    }
  });
}
